<template>
  <div class="quickly-container">
    <div class="total-area">
      <p class="search-key">共为您找到 <label>{{total}}</label> 条客户信息</p>
      <div class="btns">
        <span class="toggle" @click="showSearchBox = !showSearchBox">{{showSearchBox ? '收起' : '查看'}}筛选条件<i :class="showSearchBox ? ' el-icon-d-arrow-right down' : 'el-icon-d-arrow-right  up'"></i></span>
        <el-button size="mini" @click="resetSearch">重选</el-button>

      </div>
    </div>
    <div class="search-operate" v-if="showSearchBox">
      <span class="item" v-for="(item,index) in searchParams" :key="index">{{item.name}}<i class="remove iconfont el-icon-remove"  @click.stop.prevent="handleRemove(index,item.id)"></i></span>
    </div>
    <div class="quickly-body">
      <el-tabs v-model="activeName" class="quickly-tab-layout">
        <template v-for="tab in tabs">
          <el-tab-pane :label="`${tab.name} (${tab.total})`" :name="tab.id" v-if="tab.hasPermission" :key="tab.id">
            <component :is="tab.component" :isFromQuickly="true" :searchParameters="parameters" @searchCallback="handleCallback" :ref="`${tab.id}Ref`"></component>
          </el-tab-pane>
        </template>
      </el-tabs>
      <div class="btn-groups">
        <el-button size="mini" class="global-btn primary-round" @click="handleSearch">搜索更多</el-button>
        <el-button size="mini" @click="handleExport">导出</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {getCompanyAgentStatus} from '@/api/system';
import {searchExport} from '@/api/base';
export default{
  name: 'QuicklyResult',
  components: {
    newYorkerComp: resolve => (require(["@/views/custome/newyorker/beDistributed"], resolve)),
    publicComp: resolve => (require(["@/views/custome/publicPool/index"], resolve)),
    privateComp: resolve => (require(["@/views/custome/customeManager/index"], resolve)),
    invalidComp: resolve => (require(["@/views/custome/invalidPool/index"], resolve)),
    blackComp: resolve => (require(["@/views/custome/blackPool/index"], resolve))
  },
  data () {
    return {
      activeName: '',
      tabs: [
        {id: 'newYorker', name: '新客池', permission: 'customer.new', hasPermission: false, total: 0, component: 'newYorkerComp'},
        {id: 'public', name: '公客池', permission: 'customer.public', hasPermission: false, total: 0, component: 'publicComp'},
        {id: 'private', name: '私客池', permission: 'customer.my.list', hasPermission: false, total: 0, component: 'privateComp'},
        {id: 'invalid', name: '无效池', permission: 'customer.invalid', hasPermission: false, total: 0, component: 'invalidComp'},
        {id: 'black', name: '黑名单', permission: 'customer.black', hasPermission: false, total: 0, component: 'blackComp'}
      ],
      parameters: {},
      searchParams:[],
      showSearchBox:true
    }
  },
  computed: {
    total () {
      let num = 0;
      this.tabs.map(v => num += v.total);
      return num;
    }
  },
  watch: {
    //监听路由地址的改变
    $route: {
      deep: true,
      handler () {
        const query = this.$route.query;
        this.parameters = query.data;
        this.searchParams = query.searchKey;
        // 刷新当前所有页面
        this.$nextTick(_ => {
          this.tabs.map(v => {
            if (this.$refs[v.id + 'Ref']) {
              this.$refs[v.id + 'Ref'][0].initSearchList();
            }
          })
        })
      }
    },
  },
  async created() {
    // 解析参数
    const query = this.$route.query;
    if(query.data && query.data.a){
      this.parameters = query.data;
      this.searchParams = query.searchKey;
    }else{
      const url = `/workspace/search/quickly-result`;
      this.$router.replace(url);
    }
    // 检验权限
    const agentType = await this.getAgentStatus();
    this.tabs.map(async (v, i) => {
      const status = await this.$store.dispatch('user/hasPermission', v.permission);
      // 新客池判断
      let hasPermission = status;
      if (v.id == 'newYorker') {
        hasPermission = status && agentType != 4;
        this.$set(this.tabs[i], 'hasPermission', hasPermission);
      } else {
        this.$set(this.tabs[i], 'hasPermission', status);
      }
      if (this.activeName == 0 && hasPermission) {
        this.activeName = v.id;
      }
    })
  },

  methods: {
    getAgentStatus () {
      return new Promise(async resolve => {
        try {
          const res = await getCompanyAgentStatus();
          resolve(res.agent_type);
        } catch (error) {
          resolve(0);
        }
      })
    },
    handleCallback (name, num) {
      const index = this.tabs.findIndex(v => v.id == name);
      this.$set(this.tabs[index], 'total', num);
    },
    handleSearch () {
      this.$EventBus.$emit('quicklySearch', 1);
    },
    resetSearch(){
      this.searchParams = {};
      this.parameters = {};
      this.$EventBus.$emit('quicklySearch', 1);
    },
    handleRemove(index,id){
      if(this.searchParams.length == 1){
        this.$message.error('最少需要选中一个条件哦!');
        return null;
      };
      this.$set(this.parameters, id,'');
      this.searchParams.splice(index,1);
    },
    async handleExport () {
      try {
        await searchExport(this.parameters);
        this.$EventBus.$emit(`importAnimate`, 1);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    }
  },
}
</script>
<style lang="less" scoped>
.page-alive-group{
  display: none!important;
}
.quickly-container{
  padding: 10px 20px;
  .search-key{
    font-size: 13px;
    color: #666;
    label{
      font-weight: bold;
      color: red;
    }
  }
  .quickly-tab-layout{
    background: #fff;
    margin-top: 20px;
    height: calc(100VH - 160px);
    border-radius: 5px;
  }
  .quickly-body{
    position: relative;
  }
  .btn-groups{
    position: absolute;
    top: 5px;
    right: 20px;
    z-index:100;
  }
}
</style>
<style lang="less">
.quickly-container{
  .total-area{
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #fff;
    .search-key{
      line-height: 30px;
    }
    .btns{
      .toggle{
        color:#3F80FE;
        font-size:14px;
        margin-right:20px;
        cursor: pointer;
        .up{
          transform: rotate(90deg);
        }
        .down{
          transform: rotate(-90deg);
        }
      }
    }
  }
  .quickly-tab-layout{
    .el-tabs__nav-scroll{
      padding-left: 20px;
    }
    .el-tabs__content{
      padding: 0 20px;
    }
  }
}
.search-operate {
  margin-top:20px;
  .item{
    position: relative;
    height:30px;
    line-height: 27px;
    padding:0 10px;
    border:1px solid #DEDEDE;
    border-radius: 3px;
    color:#666;
    font-size:12px;
    margin-right:10px;
    display: inline-block;
    .remove{
      position: absolute;
      right: -8px;
      top: -8px;
      color: #b0adad;
      cursor: pointer;
      display: none;
    }
    &:hover{
      border-color: #3F80FE;
      color:#3F80FE;
      background: #EEF5FF;
      .remove{display: block;}
    }
  }

}
</style>